import { IDashboardContext } from "../../../contexts/dashboard-context";

export function isBackgroundColorPanelSupported(
	spread: eXpress.core.Spread | null | undefined,
	dashboard: IDashboardContext,
) {
	// We currently don't check if there are colors
	return (
		!!spread?.definition?.product.showBackgroundColorTab &&
		dashboard.canApplyBackgroundToSpread(spread)
	);
}
